/** Row shape used by users list + stats cards (minimal fields for counts / filters). */
export type UsersStatsUserRow = {
    isActive?: boolean;
    lastLoginAt?: string | Date | null;
    invite?: {
        sentAt?: string | Date;
        accepted?: boolean;
        expired?: boolean;
    } | null;
};

/** Invite sent, not accepted, not expired, and user has never signed in. */
export function isPendingInviteForStats(user: UsersStatsUserRow): boolean {
    const inv = user?.invite;
    if (inv?.sentAt == null || inv.sentAt === '') return false;
    if (inv.expired) return false;
    if (inv.accepted === true) return false;
    if (user?.lastLoginAt != null && user.lastLoginAt !== '') return false;
    return true;
}

/** Matches “Enabled” stat card: active account and not in pending-invite bucket. */
export function isEnabledCardUser(user: UsersStatsUserRow): boolean {
    if (isPendingInviteForStats(user)) return false;
    return user?.isActive === true;
}

/** Matches “Disabled” stat card: inactive and not in pending-invite bucket. */
export function isDisabledCardUser(user: UsersStatsUserRow): boolean {
    if (isPendingInviteForStats(user)) return false;
    return user?.isActive === false;
}

/** Aligns with stats cards + hero status filter values. */
export function matchesUserListStatusFilter(
    user: UsersStatsUserRow,
    status: string | undefined,
): boolean {
    if (status == null || status === 'All') return true;
    if (status === 'enabled') return isEnabledCardUser(user);
    if (status === 'disabled') return isDisabledCardUser(user);
    if (status === 'pendingInvite') return isPendingInviteForStats(user);
    return true;
}
